import React from 'react'
import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom'
import { ApolloProvider } from 'Apollo'

import { StripeProvider } from 'react-stripe-elements'

// import { Auth } from 'Auth'
import { EditorProvider } from 'providers/Editor'
import { UploadProvider } from 'providers/Upload'
import { Routes } from 'Routes'
// import registerServiceWorker from './registerServiceWorker'

import 'styles/index.css'


Sentry.init({
 dsn: process.env.REACT_APP_SENTRY_DSN
});

ReactDOM.render(
    <ApolloProvider>
        <StripeProvider apiKey={ process.env.REACT_APP_STRIPE_PUBLIC_KEY }>
            <EditorProvider>
                <UploadProvider>
                    <Routes />
                </UploadProvider>
            </EditorProvider>
        </StripeProvider>
    </ApolloProvider>
, document.getElementById('root'))
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js